import React, { Component } from 'react';
import { loadJS } from './loadJS';

let config = {};

function setConfig(nextConfig) {
    config = {
        ...config,
        ...nextConfig,
    };
}

export const useJS = function(useList, func) {
    return class Wrapper extends Component {
        constructor(props) {
            super(props);
            this.state = {
                loaded: false,
                args: [],
            };
        }

        componentDidMount() {
            if (Array.isArray(useList)) {
                Promise.all(
                    useList.map(dep => {
                        let path, component;
                        if (config[dep]) {
                            path = config[dep];
                            component = dep;
                        } else if (/\.js$/.test(dep)) {
                            path = dep;
                            component = dep.substr(0, dep.length - 3);
                        } else {
                            path = dep + '.js';
                            component = dep;
                        }
                        return new Promise(resolve => {
                            loadJS(
                                path,
                                () => {
                                    let res = null;
                                    try {
                                        res = window[component].default;
                                        if(!res && typeof window[component] === "object"){
                                            res = window[component];
                                        }
                                    } catch (e) {}
                                    resolve(res);
                                },
                                () => {
                                    resolve(null);
                                },
                            );
                        });
                    }),
                ).then(args => {
                    this.setState({
                        loaded: true,
                        App: func(...args),
                    });
                });
            } else {
                this.setState({
                    loaded: true,
                    App: func(),
                });
            }
        }

        render() {
            let { loaded, App } = this.state;
            if (loaded) {
                return <App {...this.props} />;
            } else {
                return null;
            }
        }
    };
};

export const useJSHoc = ({ useMap } = {}) => App => {
    return class Wrapper extends Component {
        constructor(props) {
            super(props);
            this.state = { loaded: false };
            this.useMap = {};
        }

        componentDidMount() {
            let useMapKeys = Object.keys(useMap);
            if (useMap && useMapKeys) {
                Promise.all(
                    useMapKeys.map(key => {
                        let path = useMap[key];
                        let component = key;
                        return new Promise(resolve => {
                            loadJS(
                                path,
                                () => {
                                    let res = null;
                                    try {
                                        res = window[component].default;
                                        if (!res && typeof window[component] === "object") {
                                            res = window[component];
                                        }
                                    } catch (e) { }
                                    resolve({ name:component, res: res });
                                },
                                () => {
                                    resolve(null);
                                },
                            );
                        });
                    }),
                ).then(args => {
                    if(Array.isArray(args)){
                        args.forEach(e=>this.useMap[e.name] = e.res);
                    }
                    this.setState({ loaded: true });
                });
            } else {
                this.setState({ loaded: true });
                this.useMap = {};
            }
        }

        render() {
            let { loaded } = this.state;
            if (loaded) {
                return <App {...this.props} useMap={this.useMap} />;
            } else {
                return null;
            }
        }
    };

};

useJS.setConfig = setConfig;

// DEMO:

// useJS.setConfig({ 'print/print/print/main/index': '../../../../print/print/print/main/index.js' });

// let PrintOutput = useJS(['print/print/print/main/index'], PrintOutput => {
//     return class App extends Component {
//         render() {
//             return <PrintOutput {...this.props} />;
//         }
//     };
// });

